import * as BCBSTokens from '@hcsc-fiber/tokens/dist/fiber/fiber';
import * as HealthSpringTokens from '@hcsc-fiber/tokens/dist/healthspring/fiber';
import { BRAND_CODES, type BrandCode } from '../brand';

const bcbsTheme = {
  ...BCBSTokens,
};

const healthSpringTheme = {
  ...HealthSpringTokens,
};

export const getThemeForBrand = (brandCode: BrandCode) => {
  if (brandCode === BRAND_CODES.HEALTHSPRING) {
    return healthSpringTheme;
  }

  return bcbsTheme;
};

export default bcbsTheme;
